import * as React from 'react';
import { Button } from '../../../../components/button/Button';
import ResultDialog from '../../../../components/dialog-types/ResultDialog';
import { TextArea } from '../../../../components/form-elements/_index';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { PageNames } from '../../../../utils/app-constants';
import { BackorderStatusFlyout } from '../../../../modules/ordering/components/BackOrderStatusFlyout';
import "../../../../modules/ordering/styles.scss";

export const BackorderScene = () => {

    const [orderIds, setOrderIds]               = React.useState('');
    const [isFlyoutOpen, setIsFlyoutOpen]       = React.useState(false);

    /**
     * Handler for changing the cutoff date.
     * @param newDate The new cutoff date as chosen 
     */
    const onShipmentIdChange = (e : any) => {    
        setOrderIds(e.target.value);
    };

    const onReset = () => {
        setOrderIds('');
    };

    /** 
     * Format the dates and initiate the run credit report command
     */
    const backorderThem = async () => {

        const result = await ResultDialog.show({
            title: 'Backorder Orders?',
            message: 'Are you sure you want to backorder these orders?  They will be removed from any pickups, deliveries and production runs they are currently assigned to.'
        });

        if (result) {
            setIsFlyoutOpen(true);
        }
    };

    /**
     * Close the flyout
     */
    const closeFlyout = () => {
        setIsFlyoutOpen(false);
        onReset();
    };

    return (
        <PageContent pageName={PageNames.ORDERING_ORDER_LOOKUP}>
            <PageHeading>
                <button 
                    className="btn new negative"
                    onClick={ onReset }>
                    Reset
                </button>
            </PageHeading>
            <PageBody>
                <div className="row justify-content-around">
                    <div className="col">
                        <p>Enter the order IDs you want to backorder below, 1 ID per line</p>
                        <TextArea
                            id="shipmentIds"
                            className="reporting-shipmentexport-textarea"
                            label="Order IDs"
                            value={ orderIds }
                            allowReturn={ true }
                            onChange={ onShipmentIdChange } />
                        <Button 
                            id="backorder-btn" 
                            testID="backorder-btn" 
                            text="Backorder" 
                            disable={ orderIds.length === 0 }
                            onBtnClick={ backorderThem } 
                        />
                    </div>
                </div>

                <BackorderStatusFlyout
                    isOpen={ isFlyoutOpen }
                    onClose={ closeFlyout }
                    orders={ orderIds }
                />

            </PageBody>
        </PageContent>
    );
};
